export default "__VITE_ASSET__D7GyHx_K__"